export default {
    select: 'Select',
    cancel: 'Cancel'
}
